// Module
var code = `{{#cards}}
<div class="rounded-xl bg-gray-50 p-2 shadow-sm">
  <div class="flex p-4">
    {{svgIcon}}
    <h3 class="ml-2 text-sm font-medium">{{title}}</h3>
  </div>
  <p
    class="font-lusitana truncate rounded-xl bg-white px-4 py-8 text-center text-2xl"
    data-card-value="{{attrCardType}}"
  >
    {{value}}
  </p>
</div>
{{/cards}}
`;
// Exports
module.exports = code;